var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClipboard = function SvgIconClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.536 2.75q.052-.055.105-.109a4.75 4.75 0 0 1 6.823.109h3.286A1.75 1.75 0 0 1 20.5 4.5v15.75A1.75 1.75 0 0 1 18.75 22H5.25a1.75 1.75 0 0 1-1.75-1.75V4.5a1.75 1.75 0 0 1 1.75-1.75zm1.52 1.305a2.75 2.75 0 0 1 4.683 1.695H9.26a2.75 2.75 0 0 1 .795-1.695m-2.639.695H5.5V20h13V4.75h-1.917c.11.404.167.824.167 1.25v.75a1 1 0 0 1-1 1h-7.5a1 1 0 0 1-1-1V6c0-.426.057-.846.167-1.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconClipboard;